import { createContext, useEffect, useLayoutEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getCheckpointStep } from '../Checkpoints/checkpoints';

const initialLog = '';

export const StepperContext = createContext({});
const { Provider } = StepperContext;

export const StepperProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const previousCheckpoint = searchParams.get('checkpoint');
  const previousCompanyId = searchParams.get('id');

  const [currentStep, setCurrentStep] = useState(0);
  const [currentCheckpoint, setCurrentCheckpoint] = useState(undefined);
  const [loggerCache, setLoggerCache] = useState(initialLog);
  const [companyId, setCompanyId] = useState(undefined);
  const [companyEmail, setCompanyEmail] = useState(undefined);
  const [companyName, setCompanyName] = useState(undefined);
  const [canNextStep, setCanNextStep] = useState(false);
  const [bypassList, setBypassList] = useState([]);

  useLayoutEffect(() => {
    if (previousCheckpoint === undefined || previousCheckpoint === null) return;
    setCurrentCheckpoint(previousCheckpoint);
    const redirectStep = getCheckpointStep(previousCheckpoint);
    if (redirectStep === undefined) return;
    console.log('setup is redirecting to step ', redirectStep);
    setCurrentStep(redirectStep);
  }, [previousCheckpoint]);

  useLayoutEffect(() => {
    if (previousCompanyId === undefined || previousCompanyId === null) return;
    setCompanyId(previousCompanyId);
  }, [previousCompanyId]);

  const clearlogs = () => {
    setLoggerCache(initialLog);
  };

  const addLogs = (stringLog) => {
    if (typeof stringLog !== 'string') return;
    setLoggerCache(stringLog);
  };

  useEffect(() => {
    console.log(companyId);
  }, [companyId]);

  return (
    <Provider
      value={{
        currentStep,
        setCurrentStep,
        currentCheckpoint,
        companyId,
        companyEmail,
        companyName,
        setCompanyId,
        setCompanyEmail,
        setCompanyName,
        addLogs,
        loggerCache,
        clearlogs,
        canNextStep,
        setCanNextStep,
        bypassList,
        setBypassList,
      }}
    >
      {children}
    </Provider>
  );
};
